import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum LeaseTransactionJudge {
  useRightsLease = '1',
  smallSumAssetLease = '2',
  shortLease = '3',
}

const nameConfig = {
  useRightsLease: new Map([[Locale.ja, '使用権リース']]),
  smallSumAssetLease: new Map([[Locale.ja, '少額資産リース']]),
  shortLease: new Map([[Locale.ja, '短期リース']]),
};

const toEnum = rawValueToEnum(LeaseTransactionJudge, LeaseTransactionJudge.useRightsLease);
const toDisplay = enumToName(LeaseTransactionJudge, nameConfig);
const toDisplayWithPrefix = enumToName(LeaseTransactionJudge, nameConfig, { prefix: true });

export const leaseTransactionJudge = {
  enum: LeaseTransactionJudge,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LeaseTransactionJudge };
